import { render, staticRenderFns } from "./user_dpfw_add.vue?vue&type=template&id=f6b264cc&scoped=true"
import script from "./user_dpfw_add.vue?vue&type=script&lang=js"
export * from "./user_dpfw_add.vue?vue&type=script&lang=js"
import style0 from "./user_dpfw_add.vue?vue&type=style&index=0&id=f6b264cc&prod&scoped=true&lang=less"
import style1 from "./user_dpfw_add.vue?vue&type=style&index=1&id=f6b264cc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b264cc",
  null
  
)

export default component.exports